import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        snack: '',
        color: '',
    },
    mutations: {
        setColor (state, color) {
          state.color = color
        },
        setSnack (state, snack) {
          state.snack = snack
        },
        showSnack (state, color, snack) {
          state.color = color
          state.snack = snack
        }
    }
})
